import React, { useState } from 'react';
import { Dropdown, Tag, Button, Modal } from 'antd';
import { DeleteOutlined, EditOutlined } from '@ant-design/icons';
import { message } from 'antd';
import '../../styles/Dashboard.css';
import { useNavigate } from 'react-router-dom';
import { API_URL, API_username, API_password } from '../../utils/api';

const RequestsContent = ({employeeRequests, isAnnualLeaveRequestExist, isUnpaidLeaveRequestExist, isResignationRequestExist}) => {
    const navigate = useNavigate();

    // Объект с цветами для статусов документов
    const tagColors = {
        'Не согласован': 'red',
        'Отклонен': 'red',
        'Отклонено': 'red',
        'Проект': 'gray',
        '': 'blue',
    };

    const docTypeMapping = {
        'Решение об отпуске': 'Заявление на отпуск',
        'Решение об отпуске без сохранения оплаты': 'Заявление на отпуск без сохранения оплаты',
        'Решение об увольнении': 'Заявление на увольнение',
    };

    // Форматирование даты
    const formatDate = (date) => {
        const rawDate = date.split('T')[0];
        const dateParts = rawDate.split('-');
        return `${dateParts[2]}.${dateParts[1]}.${dateParts[0]}`;
    };

    // Функция для обработки кликов по элементам меню
    const onMenuClick = (e) => {
        switch(e.key) {
            case 'отпуск':
                navigate('/annual_leave_request', { state: { isExist: isAnnualLeaveRequestExist } });
                break;
            // case 'увольнение':
            //     navigate('/resignation_request', { state: { isExist: isResignationRequestExist } });
            //     break;
            case 'отпуск без сохранения оплаты':
                navigate('/unpaid_leave_request', { state: { isExist: isUnpaidLeaveRequestExist } });
                break;
            default:
                break;
        }
    };

    const items = [
        {
            key: 'отпуск',
            label: 'Отпуск',
        },
        {
            key: 'отпуск без сохранения оплаты',
            label: 'Отпуск без сохранения оплаты',
        },
        // {
        //     key: 'увольнение',
        //     label: 'Увольнение',
        // },
    ];

    const handleEditClick = (request) => {
        switch(request.DocType) {
            case 'Решение об отпуске':
                navigate('/edit_annual_leave_request', { state: { request: request } });
                break;
            case 'Решение об отпуске без сохранения оплаты':
                navigate('/edit_unpaid_leave_request', { state: { request: request } });
                break;
            case 'Решение об увольнении':
                navigate('/edit_resignation_request', { state: { request: request } });
                break;
        }
    }

    return <>  
        <div className='requests-content'>
            <Dropdown.Button
                menu={{
                    items,
                    onClick: onMenuClick,
                }}
            >
                Подать заявление на
            </Dropdown.Button>

            {/* Таблица заявлений */}
            <table className='applicationsTable' style={{ marginTop: '16px' }}>
                <thead>
                    <tr>
                        <th><p>Номер заявления</p></th>
                        <th><p>Дата заявления</p></th>
                        <th><p>Вид заявления</p></th>
                        <th><p>Состояние</p></th>
                        <th><p>Ответственный</p></th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {employeeRequests.map((request, index) => (
                        <tr key={index}>
                            <td><p>{request.DocNumber}</p></td>
                            <td><p>{formatDate(request.DocDate)}</p></td>
                            <td><p>{docTypeMapping[request.DocType] || request.DocType}</p></td>
                            <td>
                                <p>
                                    <Tag color={tagColors[request.DocStatus] || 'green'}>
                                        {request.DocStatus || 'На рассмотрении'}
                                    </Tag>
                                </p>
                            </td>
                            <td><p>{request.Specialist}</p></td>
                            <td style={{ textAlign: 'center' }}>
                                {request.DocStatus === '' && (
                                    <button className='btn' style={{ backgroundColor: '#fff', border: '1px solid #c9c9c9' }} onClick={() => handleEditClick(request)}><EditOutlined /></button>
                                )}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    </>;
};

export default RequestsContent;
